import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { getUser, signIn as sendSignInRequest, refresh as refreshRequest } from '../api/auth';
import type { User, AuthContextType } from '../types';

function AuthProvider(props: React.PropsWithChildren<unknown>) {
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      (async function() {
        let data: User = { isOk: false };
        await getUser().then(res =>{
            data = res;
        }).catch(() => {
            data = { isOk: false };
        });
      setUser(data);
      setLoading(false);
    })();
  }, []);

    const signIn = useCallback(async(email: string, password: string) =>{
        const result: User = await sendSignInRequest(email, password);
    if (await result.isOk) {
      setUser(result);
    }

    return result;
  }, []);

    const signOut = useCallback(async(refresh: boolean) =>{
        if (refresh === true) {
            // Attempt a silent token refresh
            const refreshed = await refreshRequest();
            if (refreshed.isOk) {
                // Token refreshed — update React state so components re-render
                // with the new token (OData stores depend on user?.token).
                setUser(refreshed);
                return;
            }
        }

        // Actual logout (or refresh failed)
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setUser(undefined);
    }, []);

  return <AuthContext.Provider value={{ user, signIn, signOut, loading }} {...props} />;
}

const AuthContext = createContext<AuthContextType>({ loading: false } as AuthContextType);
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
